import Select from "./Select";

export type { ISelectProps, ISelectOption } from "./types";

export default Select;
